import React from 'react';
import { events, quickAccess } from '../data/homepage';
export function Events() {
  return <section aria-labelledby="events-title" className="relative overflow-hidden bg-ville-navy" data-id="element-1140" data-mp="2c8qe24eclvhl">
      <svg aria-hidden="true" viewBox="0 0 400 600" preserveAspectRatio="none" className="pointer-events-none absolute -right-10 top-0 hidden h-full w-[420px] lg:block" data-id="element-1141" data-mp="2gzysjeujc71m">
        <path d="M420,40 C300,120 360,220 270,300 C180,380 260,470 150,560" fill="none" stroke="#2fe1a0" strokeWidth="2" opacity="0.35" data-id="element-1142" data-mp="2m0w9xp7q0x22" />
      </svg>

      <div className="relative mx-auto grid max-w-[1400px] gap-12 px-5 pb-20 pt-8 lg:grid-cols-[minmax(0,34%)_minmax(0,1fr)] lg:gap-16 lg:px-10" data-id="element-1143" data-mp="1tb5qr1r8f4z3">
        <div data-id="element-1144" data-mp="1yba62ogeltnq">
          <p className="text-center font-display text-lg font-extrabold text-white lg:text-right" data-id="element-1145" data-mp="238ah7ds41mlp">
            What’s Happening
          </p>
          <h2 id="events-title" className="mt-1 text-center font-display text-4xl font-extrabold leading-tight tracking-tight text-ville-lime sm:text-5xl lg:text-right" data-id="element-1146" data-mp="39nb46tz5qug5">
            Upcoming Events
          </h2>

          <ul className="mt-8 space-y-5" data-id="element-1147" data-mp="2jsitjrvl1o9l">
            {events.map(event => <li key={event.id} className="flex items-start gap-4" data-id="element-1148" data-mp="2fqxnapdk088d">
                <span className="grid h-[62px] w-[62px] shrink-0 place-content-center rounded-md border border-white/40 text-center leading-none" data-id="element-1149" data-mp="2fpme2a1ca89v">
                  <span className="text-[11px] font-bold uppercase tracking-wider text-white" data-id="element-1150" data-mp="25s83gr23kdph">{event.month}</span>
                  <span className="mt-1 font-display text-2xl font-extrabold text-ville-lime" data-id="element-1151" data-mp="20vre5tj5vtat">{event.day}</span>
                </span>
                <span className="min-w-0" data-id="element-1152" data-mp="1w1n431eln55i">
                  <span className="block text-sm text-white/90" data-id="element-1153" data-mp="1s2xw5ocbyft9">{event.time}</span>
                  <a href="#accueil" className="mt-1 block font-display text-[17px] font-extrabold leading-snug text-ville-spring underline-offset-4 transition-colors duration-150 ease-ville hover:underline focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-spring" data-id="element-1154" data-mp="1n3bft617gjg8">
                    {event.title}
                  </a>
                </span>
              </li>)}
          </ul>

          <p className="mt-7" data-id="element-1155" data-mp="18ft77wkiv4oj">
            <a href="#accueil" className="text-[15px] font-semibold text-white underline-offset-4 transition-colors duration-150 ease-ville hover:text-ville-spring hover:underline focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-spring" data-id="element-1156" data-mp="18gw0gb5bhj7m">
              View Calendar
            </a>
          </p>
        </div>

        <div data-id="element-1157" data-mp="1m89ej9kghov9">
          <p className="text-center font-display text-lg font-extrabold text-white lg:text-left" data-id="element-1158" data-mp="1m9u1oe4fy5j3">
            Looking For Something?
          </p>
          <h2 className="mt-1 text-center font-display text-4xl font-extrabold tracking-tight text-ville-lime sm:text-5xl lg:text-left" data-id="element-1159" data-mp="1de4kkha0zxbi">
            Quick Access
          </h2>

          <div className="mt-8 grid gap-x-10 gap-y-8 sm:grid-cols-2" data-id="element-1160" data-mp="255tvlugzbj5b">
            {quickAccess.map(group => <section key={group.title} aria-labelledby={`quick-${group.title}`} data-id="element-1161" data-mp="29wtuv6dkmdaz">
                <h3 id={`quick-${group.title}`} className="font-display text-xl font-extrabold tracking-tight text-white" data-id="element-1162" data-mp="3unha6w7evol7">
                  {group.title}
                </h3>
                <ul className="mt-2.5 list-disc space-y-1.5 pl-5 marker:text-ville-spring" data-id="element-1163" data-mp="3pmbhuzhny3c7">
                  {group.links.map(link => <li key={link} data-id="element-1164" data-mp="38tfb9hj3eoi">
                      <a href="#accueil" className="text-[15px] text-ville-spring underline-offset-4 transition-colors duration-150 ease-ville hover:text-white hover:underline focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-spring" data-id="element-1165" data-mp="38jqvqc4tfkx">
                        {link}
                      </a>
                    </li>)}
                </ul>
              </section>)}
          </div>
        </div>
      </div>
    </section>;
}